import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Subscription, finalize, take } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ISortState } from './profile.interface';

import { ModalController } from '@ionic/angular';


import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import {
  Funcionalidade,
  GroupPermissionsService,
  Restricao,
  SubFuncionalidade,
} from 'src/app/modules/services/group-permissions/group-permissons.service';
import { UserService } from '../../services/user/user.service';
import { ProfileService } from '../../services/profile/profile.service';
import { LoadingService } from '../../components/loading/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionModalComponent } from '../../components/permission-modal/permission-modal.component';
import { Permission } from '../../components/permission-modal/permission.interface';
import { CONFIGURATION_ROOT_NAMES } from '../../shared/constants/configuration-roots';

type Action = 'Habilitar' | 'Edição' | 'Inclusão' | 'Exclusão';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.scss'],
})
export class ProfileFormComponent implements OnInit {
  // @ViewChild('menus', { static: true }) menusElement?: ElementRef;

  @Input() isEditMode: boolean = false;
  hide = true;
  subscriptions: Subscription[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  form: FormGroup;
  profileId: string | null = null;

  menus: Funcionalidade[] = [];
  restrictions: Restricao[] = [];
  permissionsData: Record<any, any> = {};
  menuId: string = '';
  isAdmin: boolean = false;

  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 1;
  totalElements: number = 0;
  sortState: ISortState = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  displayedColumns: string[] = ['nome', 'email', 'removeAction'];
  dataSource = new MatTableDataSource<any>([]);

  emailFilter: string = '';
  nameFilter: string = '';
  statusFilter: string = '';

  filteredUsers: any[] = [];
  searchTerm: string = '';
  selectedUser: any = null;

  permissions: Permission[] = [];
  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  disabledTooltipMessage: string = 'Ação não permitida';
  currentRoute: string = '';
  validUserToAdd: boolean = false;
  invalidUserToAdd: boolean = false;

  isMaster: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private userService: UserService,
    private profileService: ProfileService,
    private router: Router,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private pageSizeService: PageSizeService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private groupPermissionsService: GroupPermissionsService
  ) {
    this.form = this.fb.group({
      profileName: [null, [Validators.required, Validators.minLength(3)]],
      userFilterInput: [''],
    });
    iconRegistry.addSvgIcon(
      'add-profile',
      sanitizer.bypassSecurityTrustResourceUrl('assets/user/add-user.svg')
    );
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.currentRoute = this.router.url;
    this.loadUserInfo();

    this.route.paramMap.subscribe((params) => {
      this.profileId = params.get('id');
      if (this.profileId) {
        this.loadProfileData(this.profileId);
      }
    });

    try {
      this.loadingService.showLoading();

      this.loadMenus();
      this.loadGroupPermissions();
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async loadGroupPermissions() {
    const response = await this.groupPermissionsService
      .getRestricoes()
      .toPromise();
    this.restrictions = response ?? [];
  }

  isMenuChecked(subFuncionalidade: SubFuncionalidade, action: Action) {
    if (this.isAdmin) {
      if (action === 'Habilitar') {
        return true;
      }

      return false;
    }

    return this.permissionsData[subFuncionalidade.id]?.[action] ?? false;
  }

async loadMenus() {
  const response = await this.groupPermissionsService.getMenus().toPromise();
  this.menus = (response as Funcionalidade[]) || [];

  if (this.mainMenus.length > 0) {
    this.menuId = this.mainMenus[0].id;
  } else if (this.menus.length > 0) {
    this.menuId = this.menus[0].id;
  }
}

  get mainMenus() {
    return this.menus
      .filter((funcionalidade) => !this.isConfigurationRoot(funcionalidade.nome))
      .map((funcionalidade) => {
      const subFuncionalidades: { id: string; nome: string }[] = [];

      funcionalidade.subFuncionalidades.forEach((sub:any) => {
        if (sub.subFuncionalidades.length === 0) {
          return;
        }

        subFuncionalidades.push({
          id: sub.id,
          nome: sub.nome,
        });
      });

      return {
        id: funcionalidade.id,
        nome: funcionalidade.nome,
        subFuncionalidades,
      };
    });
  }

  private isConfigurationRoot(nome: string) {
    return CONFIGURATION_ROOT_NAMES.includes(nome);
  }

  handleMenuChange(id: string) {
    const menu = this.mainMenus.find((menu) => menu.id === id);

    if (menu?.subFuncionalidades?.length ?? 0 > 0) {
      this.menuId = menu!.subFuncionalidades[0].id;
    } else {
      this.menuId = id;
    }
  }

  isMenuActive(id: string) {
    return this.menuId === id;
  }

  isSubmenuActive(id: string) {
    const menu = this.mainMenus.find((menu) => menu.id === id);

    if (!menu) return false;

    if (menu.subFuncionalidades.length > 0) {
      return (
        menu.subFuncionalidades.findIndex((sub) => sub.id === this.menuId) >= 0
      );
    }

    return false;
  }

  get menuSubFuncionalidades(): SubFuncionalidade[] {
    for (const funcionalidade of this.menus) {
      if (funcionalidade.id === this.menuId) {
        return funcionalidade.subFuncionalidades;
      }

      for (const sub of funcionalidade.subFuncionalidades) {
        if (sub.id === this.menuId) {
          return sub.subFuncionalidades;
        }
      }
    }

    return [];
  }

  handleEnableAll(event: any) {
    const checked = event.detail.checked;

    this.menuSubFuncionalidades.forEach((subFuncionalidade) => {
      this.handleCheckMenu(subFuncionalidade, 'Habilitar', null, checked);
    });
  }

  handleCheckMenu(
    subFuncionalidade: SubFuncionalidade,
    action: Action,
    event?: any,
    checked?: boolean
  ) {
    if (!this.permissionsData[subFuncionalidade.id]) {
      this.permissionsData[subFuncionalidade.id] = {
        Habilitar: false,
        Edição: false,
        Inclusão: false,
        Exclusão: false,
      };
    }

    this.permissionsData[subFuncionalidade.id][action] =
      checked ?? !this.permissionsData[subFuncionalidade.id][action];

    if (
      action === 'Habilitar' &&
      (checked === false ||
        this.permissionsData[subFuncionalidade.id][action] === false)
    ) {
      delete this.permissionsData[subFuncionalidade.id];
    }

    this.cdr.detectChanges();
    event?.target?.blur();
  }

  get isAllEnabled() {
    return this.menuSubFuncionalidades.every((subFuncionalidade) =>
      this.isMenuChecked(subFuncionalidade, 'Habilitar')
    );
  }

  handleToggleAdmin(event: any) {
    const checked = event.detail.checked;
    this.isAdmin = checked;

    this.menus.forEach((menuItem) => {
      this.enableAllSubFuncionalidades(menuItem.subFuncionalidades, checked);
    });
  }

  enableAllSubFuncionalidades(
    subFuncionalidades: SubFuncionalidade[],
    checked: boolean
  ) {
    subFuncionalidades.forEach((subFuncionalidade: any) => {
      this.handleCheckMenu(subFuncionalidade, 'Habilitar', null, checked);

      subFuncionalidade.restricoes = [];

      if (subFuncionalidade.subFuncionalidades.length > 0) {
        this.enableAllSubFuncionalidades(
          subFuncionalidade.subFuncionalidades,
          checked
        );
      }
    });
  }

  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }

  checkFunctionality(functionality: any) {
    const normalizeString = (str: string): string =>
      str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]/gi, '')
        .toLowerCase();

    const normalizedFunctionalityName = normalizeString(functionality.nome);
    const normalizedRoute = normalizeString(this.currentRoute);

    if (normalizedFunctionalityName === normalizedRoute) {
      this.handleRestrictions(functionality.restricoes);
    }

    if (
      functionality.subFuncionalidades &&
      functionality.subFuncionalidades.length > 0
    ) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        if (subFunctionality.nome === 'Perfis de usuários') {
          this.handleRestrictions(subFunctionality.restricoes);
        }
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }

  loadProfileData(profileId: string) {
    this.loadingService.showLoading();

    this.subscriptions.push(
      this.profileService
        .getProfile(profileId)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            this.form.patchValue({ profileName: response.nome });
            this.permissions = response.permissaoPerfis;
            this.permissionsData = response.permissaoPerfis;
            this.dataSource.data = response.users;
            this.isMaster = response.master;
            this.isAdmin = response.admin;
            this.setPaginatorValues();
            this.populatePermissionsData(response.permissaoPerfis);
          },
          (erro:any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  populatePermissionsData(permissions: any[]) {
    permissions.forEach((item) => {
      const funcionalidade = item.funcionalidade;

      this.processDeepestSubFuncionalidades(funcionalidade);
    });
  }

  processDeepestSubFuncionalidades(funcionalidade: any) {
    if (
      !funcionalidade.subFuncionalidades ||
      funcionalidade.subFuncionalidades.length === 0
    ) {
      this.handleCheckMenu(
        { id: funcionalidade.id } as SubFuncionalidade,
        'Habilitar',
        null,
        true
      );

      funcionalidade.restricoes.forEach((restricao: any) => {
        this.handleCheckMenu(
          funcionalidade,
          restricao.nome as Action,
          null,
          true
        );
      });
    } else {
      funcionalidade.subFuncionalidades.forEach((subFuncionalidade: any) => {
        this.processDeepestSubFuncionalidades(subFuncionalidade);
      });
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  onSubmit() {
    this.loadingService.showLoading();
    this.isEditMode ? this.handleEditSubmit() : this.handleCreateSubmit();
  }

  formatProfileUsers() {
    let users = this.dataSource.data.map((u) => ({
      id: u.id,
      nome: u.nome,
      email: u.email,
    }));

    return users;
  }

  get permissionsFormData() {
    const data: any[] = [];

    const permissionsData = Object.entries(this.permissionsData).filter(
      ([key, value]) => !value.hasOwnProperty('funcionalidade')
    );

    permissionsData.forEach(([menuId, permissions]) => {
      if (!permissions['Habilitar']) return;

      const permissionEntry = {
        idMenu: menuId,
        restrictions: [] as any[],
      };

      Object.entries(permissions).forEach(([action, isEnabled]) => {
        if (!isEnabled) return;
        if (this.isAdmin) return;

        const restriction = this.restrictions.find(
          (restriction) => restriction.nome === action
        );

        if (restriction) {
          permissionEntry.restrictions.push({ id: restriction.id });
        }
      });

      data.push(permissionEntry);
    });

    return data;
  }

  handleCreateSubmit() {
    const form = this.form.value;

    const formData = {
      nome: form.profileName,
      permissions: this.permissionsFormData,
      users: this.formatProfileUsers(),
    };

    this.subscriptions.push(
      this.profileService
        .createProfile(formData)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response:any) => {
            this.toastService.showSuccess('Perfil cadastrado com sucesso.');
            this.goToProfileList();
          },
          (erro:any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  handleEditSubmit() {
    const form = this.form.value;

    const formData = {
      nome: form.profileName,
      permissions: this.permissionsFormData,
      users: this.formatProfileUsers(),
    };

    this.subscriptions.push(
      this.profileService
        .editProfile(this.profileId, formData)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response:any) => {
            this.toastService.showSuccess('Perfil alterado com sucesso.');
            this.goToProfileList();
          },
          (erro:any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  goToProfileList() {
    this.router.navigate(['/perfil-usuario']);
  }

  onSortChange(sortProperty: 'nome' | 'email') {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    const sortedUsers = this.dataSource.data.sort((a, b) => {
      let comparison = 0;
      if (a[sortProperty] > b[sortProperty]) {
        comparison = 1;
      } else if (a[sortProperty] < b[sortProperty]) {
        comparison = -1;
      }

      return this.sortState.sortDirection === 'asc' ? comparison : -comparison;
    });

    this.dataSource.data = sortedUsers;
  }

  onSortChangeKeydown(event: KeyboardEvent, sortProperty: 'nome' | 'email') {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.onSortChange(sortProperty);
    }
  }

  filterUsers() {
    if (!this.searchTerm) {
      this.validUserToAdd = false;
      this.invalidUserToAdd = false;
      return (this.filteredUsers = []);
    }

    this.loadingService.showLoading();

    return this.subscriptions.push(
      this.userService
        .getUsers(0, 500, 'asc', 'nome', this.searchTerm, '')
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            this.filteredUsers = response.content;
          },
          (erro:any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm = filterValue;
    this.selectedUser = null;
    this.invalidUserToAdd = true;
    this.validUserToAdd = false;

    if (filterValue.length >= 3 || filterValue.length === 0) {
      this.filterUsers();
    }
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.form.patchValue({ userFilterInput: user.nome });
    this.filteredUsers = [];
    this.searchTerm = '';
    this.validUserToAdd = true;
    this.invalidUserToAdd = false;
  }

  closeFilteredUsersDropdown() {
    this.filteredUsers = [];
    this.searchTerm = '';
  }

  onAddSelectedUser() {
    if (!this.selectedUser) {
      return;
    }

    const userIndex = this.dataSource.data.findIndex(
      (u) => u.id === this.selectedUser.id
    );
    if (userIndex < 0) {
      let profileUsers = this.dataSource.data;
      profileUsers.push(this.selectedUser);
      this.dataSource.data = profileUsers;
    }

    this.setPaginatorValues();

    this.form.patchValue({ userFilterInput: '' });
    this.selectedUser = null;
    this.validUserToAdd = false;
    this.invalidUserToAdd = false;
  }

  setPaginatorValues() {
    this.totalElements = this.dataSource.data.length;
    this.totalPages = Number(
      (1 + this.totalElements / this.pageSize).toPrecision(1)
    );
  }

  async openPermissionsDialog(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: PermissionModalComponent,
      backdropDismiss: false,
      componentProps: { permissions: this.permissions },
    });
    modal.present();

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.permissions = data.data;
      }
    });

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.permissions = data;
    }
  }

  removeUser(id: string) {
    const updatedProfileUsers = this.dataSource.data.filter(
      (user) => user.id !== id
    );
    this.dataSource.data = updatedProfileUsers;

    this.setPaginatorValues();
  }

  removeUserKeydown(event: KeyboardEvent, id: string) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.removeUser(id);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  handleScroll(direction: 'left' | 'right', element: HTMLElement) {
    const scrollAmount = 100;
    const scrollDirection = direction === 'left' ? -scrollAmount : scrollAmount;
    element.scrollBy({ left: scrollDirection, behavior: 'smooth' });
  }
}
